document.addEventListener('DOMContentLoaded', function () {
  // ---------- Header background on scroll ----------
  var header = document.getElementById('siteHeader');
  if (header) {
    // Header ki height naap kar CSS variable mein rakho (hero ko header ke neeche shift karne ke liye)
    var setHeaderH = function () {
      var h = header.offsetHeight + (header.classList.contains('scrolled') ? 16 : 0);
      document.documentElement.style.setProperty('--header-h', h + 'px');
    };
    setHeaderH();
    window.addEventListener('resize', setHeaderH);
    window.addEventListener('load', setHeaderH);

    var lastY = window.scrollY;
    var hdrMenu = document.getElementById('mobileMenuOverlay');
    var hdrSearch = document.getElementById('searchOverlay');

    var headerBusy = function () {
      // Menu/search khula ho ya mouse header par ho to header chhupao mat
      return (hdrMenu && hdrMenu.classList.contains('is-open')) ||
             (hdrSearch && hdrSearch.classList.contains('is-open')) ||
             header.matches(':hover') ||
             header.contains(document.activeElement);
    };
    var showHeader = function () { header.classList.remove('header-hidden'); };
    var hideHeader = function () { if (!headerBusy()) header.classList.add('header-hidden'); };

    var onScroll = function () {
      var y = window.scrollY;
      if (y > 40) header.classList.add('scrolled');
      else header.classList.remove('scrolled');

      if (y <= 120) { showHeader(); }                    // page ke top par hamesha dikhe
      else if (y > lastY + 6) { hideHeader(); }           // neeche scroll = hide
      else if (y < lastY - 6) { showHeader(); }           // upar scroll = show
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Desktop: mouse screen ke sabse upar aaye to header dikhe
    document.addEventListener('mousemove', function (e) {
      if (e.clientY <= 70) showHeader();
    });
    // Keyboard se header mein aayein to dikhe
    header.addEventListener('focusin', showHeader);
  }

  // ---------- Mobile nav toggle ----------
  var toggle = document.getElementById('navToggle');
  var mobileMenu = document.getElementById('mobileMenuOverlay');
  var mobileMenuBackdrop = document.getElementById('mobileMenuBackdrop');
  var menuIconBars = document.getElementById('menuIconBars');
  var menuIconClose = document.getElementById('menuIconClose');

  function openMobileMenu() {
    if (mobileMenu) mobileMenu.classList.add('is-open');
    if (mobileMenuBackdrop) mobileMenuBackdrop.classList.add('is-open');
    if (menuIconBars) menuIconBars.style.display = 'none';
    if (menuIconClose) menuIconClose.style.display = '';
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    if (mobileMenu) mobileMenu.classList.remove('is-open');
    if (mobileMenuBackdrop) mobileMenuBackdrop.classList.remove('is-open');
    if (menuIconBars) menuIconBars.style.display = '';
    if (menuIconClose) menuIconClose.style.display = 'none';
    document.body.style.overflow = '';
  }
  if (toggle && mobileMenu) {
    toggle.addEventListener('click', function () {
      if (mobileMenu.classList.contains('is-open')) closeMobileMenu();
      else openMobileMenu();
    });
  }
  if (mobileMenuBackdrop) mobileMenuBackdrop.addEventListener('click', closeMobileMenu);

  // Swipe left on the drawer to close it
  if (mobileMenu) {
    var swipeStartX = null;
    mobileMenu.addEventListener('touchstart', function (e) {
      swipeStartX = e.touches[0].clientX;
    }, { passive: true });
    mobileMenu.addEventListener('touchmove', function (e) {
      if (swipeStartX === null) return;
      var dx = e.touches[0].clientX - swipeStartX;
      if (dx < -60) {
        closeMobileMenu();
        swipeStartX = null;
      }
    }, { passive: true });
    mobileMenu.addEventListener('touchend', function () { swipeStartX = null; });
  }

  // ---------- Flagship Showcase: focus carousel (center + left/right peek) ----------
  var flagSlider = document.querySelector('[data-flagship-slider]');
  if (flagSlider) {
    var fSlides = flagSlider.querySelectorAll('[data-flagship-slide]');
    var fCaps = flagSlider.querySelectorAll('[data-flagship-cap]');
    var fDots = flagSlider.querySelectorAll('[data-flagship-dot]');
    var fN = fSlides.length;
    var fIndex = 0;
    var fTimer = null;
    var fSwiped = false;
    var FLAG_DELAY = 3000;

    var fLayout = function () {
      var half = Math.floor(fN / 2);
      fSlides.forEach(function (s, i) {
        var d = ((i - fIndex + fN + half) % fN) - half;   // signed distance from center
        s.classList.toggle('is-center', d === 0);
        s.classList.toggle('is-right', d === 1);
        s.classList.toggle('is-left', d === -1);
      });
      fCaps.forEach(function (c, n) { c.classList.toggle('is-active', n === fIndex); });
      fDots.forEach(function (dt, n) { dt.classList.toggle('is-active', n === fIndex); });
    };
    var fShow = function (i) {
      if (!fN) return;
      fIndex = (i + fN) % fN;
      fLayout();
    };
    var fStop = function () { if (fTimer) { clearInterval(fTimer); fTimer = null; } };
    var fStart = function () {
      fStop();
      if (fN > 1) fTimer = setInterval(function () { fShow(fIndex + 1); }, FLAG_DELAY);
    };

    fDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        fShow(parseInt(dot.getAttribute('data-flagship-dot'), 10));
        fStart();
      });
    });

    // Side pic par click = seedha main bane. Main pic par click = link khule.
    fSlides.forEach(function (slide, i) {
      slide.addEventListener('click', function (e) {
        if (fSwiped) { e.preventDefault(); fSwiped = false; return; }
        if (!slide.classList.contains('is-center')) {
          e.preventDefault();
          fShow(i);
          fStart();
        }
      });
    });

    // (Desktop par hover-pause hata diya: slider ab poori width ka hai, mouse hamesha upar rehta tha aur auto ruk jata tha)

    // Swipe (mobile)
    var fStartX = null;
    flagSlider.addEventListener('touchstart', function (e) {
      fStartX = e.touches[0].clientX;
      fSwiped = false;
      fStop();
    }, { passive: true });
    flagSlider.addEventListener('touchend', function (e) {
      if (fStartX !== null) {
        var dx = e.changedTouches[0].clientX - fStartX;
        if (Math.abs(dx) > 40) {
          fSwiped = true;
          fShow(dx < 0 ? fIndex + 1 : fIndex - 1);
        }
      }
      fStartX = null;
      fStart();
    });

    // Tab hidden ho to ruk jaye
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) fStop(); else fStart();
    });

    fLayout();
    fStart();
  }

  // ---------- Reveal on scroll ----------
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // ---------- Search overlay ----------
  var searchToggle = document.getElementById('searchToggle');
  var searchOverlay = document.getElementById('searchOverlay');
  var searchClose = document.getElementById('searchClose');
  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', function () {
      searchOverlay.classList.toggle('is-open');
      if (searchOverlay.classList.contains('is-open')) {
        var input = searchOverlay.querySelector('input');
        if (input) setTimeout(function () { input.focus(); }, 200);
      }
    });
  }
  if (searchClose && searchOverlay) {
    searchClose.addEventListener('click', function () { searchOverlay.classList.remove('is-open'); });
  }

  // ---------- Mobile filter drawer (collection page) ----------
  var filterToggle = document.getElementById('mobileFilterToggle');
  var filterPanel = document.querySelector('.shop-filters');
  var filterBackdrop = document.getElementById('filterBackdrop');
  if (filterToggle && filterPanel && filterBackdrop) {
    filterToggle.addEventListener('click', function () {
      filterPanel.classList.add('is-open');
      filterBackdrop.classList.add('is-open');
    });
    filterBackdrop.addEventListener('click', function () {
      filterPanel.classList.remove('is-open');
      filterBackdrop.classList.remove('is-open');
    });
  }

  /* =========================================================
     Shopify Ajax Cart
     ========================================================= */
  var cartDrawer = document.getElementById('cartDrawer');
  var cartBackdrop = document.getElementById('cartBackdrop');
  var cartToggle = document.getElementById('cartToggle');
  var cartClose = document.getElementById('cartClose');
  var cartDrawerBody = document.getElementById('cartDrawerBody');
  var cartSubtotalEl = document.getElementById('cartSubtotal');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartBackdrop) cartBackdrop.classList.add('is-open');
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartBackdrop) cartBackdrop.classList.remove('is-open');
  }
  if (cartToggle) cartToggle.addEventListener('click', function () { openCart(); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);

  function formatMoney(cents) {
    return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents, window.moneyFormat || '${{amount}}')
      : 'Rs. ' + (cents / 100).toLocaleString();
  }

  function renderCartLine(item) {
    var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<span class="cart-line-variant">' + item.variant_title + '</span>' : '';
    return (
      '<div class="cart-line" data-key="' + item.key + '">' +
      '  <img src="' + item.image + '" alt="' + item.product_title + '">' +
      '  <div class="cart-line-info">' +
      '    <h5>' + item.product_title + '</h5>' +
      variantLine +
      '    <span class="cart-line-price">' + formatMoney(item.final_price) + '</span>' +
      '    <div class="cart-line-qty">' +
      '      <button type="button" class="cart-qty-btn" data-action="dec" data-key="' + item.key + '">&minus;</button>' +
      '      <span>' + item.quantity + '</span>' +
      '      <button type="button" class="cart-qty-btn" data-action="inc" data-key="' + item.key + '">+</button>' +
      '    </div>' +
      '  </div>' +
      '  <button type="button" class="cart-line-remove" data-key="' + item.key + '" aria-label="Remove">&times;</button>' +
      '</div>'
    );
  }

  function renderCart(cart) {
    if (!cartDrawerBody) return;
    if (cart.item_count === 0) {
      cartDrawerBody.innerHTML = '<p class="cart-empty-msg">Your cart is empty.</p>';
    } else {
      cartDrawerBody.innerHTML = cart.items.map(renderCartLine).join('');
    }
    if (cartSubtotalEl) cartSubtotalEl.textContent = formatMoney(cart.total_price);
    document.querySelectorAll('#cartCount').forEach(function (el) { el.textContent = cart.item_count; });
    wireCartLineEvents();
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function wireCartLineEvents() {
    document.querySelectorAll('.cart-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var line = btn.closest('.cart-line');
        var qtyEl = line.querySelector('.cart-line-qty span');
        var qty = parseInt(qtyEl.textContent, 10);
        qty = btn.getAttribute('data-action') === 'inc' ? qty + 1 : qty - 1;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function (r) { return r.json(); }).then(renderCart);
      });
    });
    document.querySelectorAll('.cart-line-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.getAttribute('data-key'), quantity: 0 })
        }).then(function (r) { return r.json(); }).then(renderCart);
      });
    });
  }
  wireCartLineEvents();

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    }).then(function () { return fetchCart(); }).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  // ---------- Add to cart (product page) ----------
  var addBtn = document.querySelector('.add-to-cart-btn');
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var variantId = addBtn.getAttribute('data-variant-id');
      var qtyEl = document.getElementById('qtyValue');
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      addToCart(variantId, qty).then(function () {
        var fb = document.getElementById('addFeedback');
        if (fb) {
          fb.textContent = 'Added to cart.';
          fb.classList.add('is-visible');
          setTimeout(function () { fb.classList.remove('is-visible'); }, 2200);
        }
        openCart();
      });
    });
  }

  /* =========================================================
     Wishlist (localStorage — client-side only)
     ========================================================= */
  function wishlistList() { return JSON.parse(localStorage.getItem('nishani_wishlist') || '[]'); }
  document.querySelectorAll('.wishlist-toggle, .wishlist-btn').forEach(function (btn) {
    var id = btn.getAttribute('data-id');
    if (wishlistList().indexOf(id) !== -1) btn.classList.add('is-active');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var list = wishlistList();
      var idx = list.indexOf(id);
      if (idx === -1) { list.push(id); btn.classList.add('is-active'); }
      else { list.splice(idx, 1); btn.classList.remove('is-active'); }
      localStorage.setItem('nishani_wishlist', JSON.stringify(list));
    });
  });

  /* =========================================================
     Quick View modal
     ========================================================= */
  var qvModal = document.getElementById('quickViewModal');
  var qvBackdrop = document.getElementById('qvBackdrop');
  if (qvModal) {
    var qvQty = 1;
    document.querySelectorAll('.quick-view-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        qvQty = 1;
        document.getElementById('qvQtyValue').textContent = '1';
        document.getElementById('qvImage').src = btn.getAttribute('data-image');
        document.getElementById('qvName').textContent = btn.getAttribute('data-name');
        document.getElementById('qvInsp').textContent = btn.getAttribute('data-vendor') || '';
        var price = btn.getAttribute('data-price');
        var compare = btn.getAttribute('data-compare');
        var priceHtml = '<span class="now">' + price + '</span>';
        if (compare) priceHtml += ' <span class="was">' + compare + '</span>';
        document.getElementById('qvPriceRow').innerHTML = priceHtml;
        document.getElementById('qvAddToCart').setAttribute('data-variant-id', btn.getAttribute('data-id'));
        document.getElementById('qvViewFull').href = btn.getAttribute('data-url');
        qvModal.classList.add('is-open');
        qvBackdrop.classList.add('is-open');
      });
    });
    document.getElementById('qvQtyMinus').addEventListener('click', function () {
      qvQty = Math.max(1, qvQty - 1);
      document.getElementById('qvQtyValue').textContent = qvQty;
    });
    document.getElementById('qvQtyPlus').addEventListener('click', function () {
      qvQty = Math.min(10, qvQty + 1);
      document.getElementById('qvQtyValue').textContent = qvQty;
    });
    function closeQuickView() {
      qvModal.classList.remove('is-open');
      qvBackdrop.classList.remove('is-open');
    }
    document.getElementById('qvClose').addEventListener('click', closeQuickView);
    qvBackdrop.addEventListener('click', closeQuickView);
    document.getElementById('qvAddToCart').addEventListener('click', function () {
      var variantId = this.getAttribute('data-variant-id');
      addToCart(variantId, qvQty).then(function () {
        closeQuickView();
        openCart();
      });
    });
  }

  /* =========================================================
     Image zoom modal (product page)
     ========================================================= */
  var zoomTrigger = document.getElementById('zoomTrigger');
  var zoomModal = document.getElementById('zoomModal');
  var zoomModalImg = document.getElementById('zoomModalImg');
  var zoomModalClose = document.getElementById('zoomModalClose');
  if (zoomTrigger && zoomModal && zoomModalImg) {
    zoomTrigger.addEventListener('click', function () {
      var img = document.getElementById('mainProductImg');
      zoomModalImg.src = img.src;
      zoomModalImg.alt = img.alt;
      zoomModal.classList.add('is-open');
    });
  }
  if (zoomModalClose) zoomModalClose.addEventListener('click', function () { zoomModal.classList.remove('is-open'); });
  if (zoomModal) zoomModal.addEventListener('click', function (e) { if (e.target === zoomModal) zoomModal.classList.remove('is-open'); });

  // ---------- Product gallery thumbnail switch ----------
  var thumbBtns = document.querySelectorAll('.thumb-btn');
  var mainImg = document.getElementById('mainProductImg');
  if (thumbBtns.length && mainImg) {
    thumbBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        mainImg.src = btn.getAttribute('data-img');
        thumbBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  // ---------- Quantity stepper (product page) ----------
  var qtyMinus = document.getElementById('qtyMinus');
  var qtyPlus = document.getElementById('qtyPlus');
  var qtyValue = document.getElementById('qtyValue');
  if (qtyMinus && qtyPlus && qtyValue) {
    qtyMinus.addEventListener('click', function () {
      qtyValue.textContent = Math.max(1, parseInt(qtyValue.textContent, 10) - 1);
    });
    qtyPlus.addEventListener('click', function () {
      qtyValue.textContent = Math.min(10, parseInt(qtyValue.textContent, 10) + 1);
    });
  }

  // ---------- Variant option switching (product page) ----------
  var variantsJsonEl = document.getElementById('productVariantsJson');
  var optionSelects = document.querySelectorAll('.variant-option-select');
  if (variantsJsonEl && optionSelects.length) {
    var variants = JSON.parse(variantsJsonEl.textContent);
    function findMatchingVariant() {
      var chosen = Array.prototype.map.call(optionSelects, function (s) { return s.value; });
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(Boolean);
        return chosen.every(function (val, i) { return opts[i] === val; });
      });
    }
    optionSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        var variant = findMatchingVariant();
        if (!variant) return;
        var hiddenId = document.getElementById('selectedVariantId');
        var addBtn = document.querySelector('.add-to-cart-btn');
        if (hiddenId) hiddenId.value = variant.id;
        if (addBtn) {
          addBtn.setAttribute('data-variant-id', variant.id);
          addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
          addBtn.disabled = !variant.available;
        }
        var priceRow = document.getElementById('priceRow');
        if (priceRow && priceRow.querySelector('.now')) {
          priceRow.querySelector('.now').textContent = formatMoney(variant.price);
        }
      });
    });
  }

  /* =========================================================
     Countdown timer (offer banner)
     ========================================================= */
  var cdEl = document.getElementById('offerCountdown');
  if (cdEl) {
    var deadlineStr = cdEl.getAttribute('data-deadline');
    var deadline = new Date(deadlineStr.replace(' ', 'T'));
    if (isNaN(deadline.getTime())) {
      deadline = new Date();
      deadline.setDate(deadline.getDate() + 3);
    }
    var cdDays = document.getElementById('cdDays');
    var cdHours = document.getElementById('cdHours');
    var cdMins = document.getElementById('cdMins');
    var cdSecs = document.getElementById('cdSecs');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tickCountdown() {
      var diff = deadline.getTime() - Date.now();
      if (diff <= 0) { cdDays.textContent = cdHours.textContent = cdMins.textContent = cdSecs.textContent = '00'; return; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      cdDays.textContent = pad(d); cdHours.textContent = pad(h); cdMins.textContent = pad(m); cdSecs.textContent = pad(s);
    }
    tickCountdown();
    setInterval(tickCountdown, 1000);
  }
});


document.addEventListener('DOMContentLoaded', function () {
  var brandSpan = document.querySelector('.brand-mark span');
  if (brandSpan) {
    var text = brandSpan.textContent;
    brandSpan.innerHTML = '';
    brandSpan.classList.add('letter-reveal-active');
    text.split('').forEach(function (ch, i) {
      var s = document.createElement('span');
      s.textContent = ch === ' ' ? '\u00A0' : ch;
      s.style.animationDelay = (i * 0.05) + 's';
      brandSpan.appendChild(s);
    });
  }
});

/* =========================================================
   Light / Dark theme toggle
   Default = light. User's choice is remembered in localStorage
   so it persists across visits and pages.
   ========================================================= */
(function () {
  var STORAGE_KEY = 'nishani_theme';

  function applyTheme(theme) {
    if (theme === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    // Multiple toggle buttons can exist (header + mobile drawer) — sync all of them.
    document.querySelectorAll('.theme-icon-moon').forEach(function (el) {
      el.style.display = theme === 'dark' ? 'none' : '';
    });
    document.querySelectorAll('.theme-icon-sun').forEach(function (el) {
      el.style.display = theme === 'dark' ? '' : 'none';
    });
  }

  // Apply saved preference (or default light) as early as possible.
  var saved = null;
  try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) {}
  applyTheme(saved === 'dark' ? 'dark' : 'light');

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.theme-toggle-btn').forEach(function (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        var isDark = document.documentElement.getAttribute('data-theme') === 'dark';
        var next = isDark ? 'light' : 'dark';
        applyTheme(next);
        try { localStorage.setItem(STORAGE_KEY, next); } catch (e) {}
      });
    });
  });
})();